import { format } from 'date-fns';

export const formatDate = (date: string | Date, formatString = 'MMM d, yyyy') => {
  try {
    return format(new Date(date), formatString);
  } catch {
    return 'Invalid date';
  }
};

export const formatDateTime = (date: string | Date) => {
  return formatDate(date, 'MMM d, yyyy HH:mm');
};

export const formatNumber = (num: number) => {
  return new Intl.NumberFormat().format(num);
};

export const formatPercentage = (num: number, decimals = 1) => {
  return `${num.toFixed(decimals)}%`;
};

export const truncateText = (text: string, maxLength: number) => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const getInitials = (firstName: string, lastName: string) => {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
};
